import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from 'tss-react/mui';
import { Typography, COLOR_VARIANTS, TYPOGRAPHY_VARIANT, Logos } from '@tajawal/ct-web-design-system';
import styles from "./FooterCompact.styled.js";
import Container from '@mui/material/Container';
import { AcceptedCards } from '@tajawal/ct-web-accepted-cards-ds';
import { COPYRIGHT, INFO_BLOCK, LANGUAGE } from "./constants/index.js";
export var CompactFooter = function CompactFooter(_ref) {
  var partnerContent = _ref.partnerContent,
    store = _ref.store,
    config = _ref.config;
  var useStyles = makeStyles()(styles);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var language = _get(config, 'language', LANGUAGE.EN);
  var configStore = _get(store, 'appStore.config', '');
  var phoneNumber = configStore.phoneNumber;
  var infoBlock = INFO_BLOCK[language];
  var displayPhoneNumber = _get(partnerContent, 'phoneNumber') || phoneNumber;
  var copyRightText = COPYRIGHT[language].replace(/{year}/g, new Date().getFullYear());
  return /*#__PURE__*/React.createElement("footer", {
    id: "compact__footer",
    className: classes.compactFooterWrap
  }, /*#__PURE__*/React.createElement(Container, {
    disableGutters: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.blockRow
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.blockRowContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.phoneNumber
  }, /*#__PURE__*/React.createElement(Logos.AlmosaferWhite, {
    width: "30",
    height: "30"
  }), /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    color: COLOR_VARIANTS.MINESHAFT,
    variant: TYPOGRAPHY_VARIANT.BODY2
  }, infoBlock.callUs, ' ', /*#__PURE__*/React.createElement(Typography, {
    component: "span",
    variant: TYPOGRAPHY_VARIANT.HEADING4SEMBLD,
    color: COLOR_VARIANTS.MINESHAFT
  }, /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noreferrer"
  }, displayPhoneNumber)))), /*#__PURE__*/React.createElement("div", {
    className: classes.copyRightText
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "p",
    color: COLOR_VARIANTS.GREYCHATEAU,
    variant: TYPOGRAPHY_VARIANT.CAPTIONREG
  }, copyRightText)), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentCards
  }, /*#__PURE__*/React.createElement(AcceptedCards, {
    config: config,
    partnerCards: _get(partnerContent, 'payment_cards', [])
  }))))));
};
export default CompactFooter;